export default "__VITE_ASSET__DPR6oB5Y__"